<div class="zesty-modal__backdrop animated fadeIn">
	<div class="zesty-modal__wrapper">
		<div class="zesty-modal" [class.onboarding-in-progress]="onboardingInProgress">
			<div class="zesty-modal__header">
				<h3 class="zesty-modal__title">{{ onboardingInProgress ? 'Onboarding accounts' : 'Finished accounts' }}</h3>
			</div>
			<div class="zesty-modal__content">

				<!--Onboarding in progress section-->
				<div [hidden]="!onboardingInProgress">
					<div class="loader-container">
						<div class="show-process__icon loading" [hidden]="!onboardingInProgress || onboardingSuccess">
							<svg class="show-process__svg-circular" viewBox="25 25 50 50">
								<circle class="show-process__svg-path" cx="50" cy="50" r="20"
												fill="none"
												stroke-width="2"
												stroke-miterlimit="10"/>
							</svg>
						</div>
						<div [hidden]="!onboardingSuccess" class="accounts-success animated fadeIn">
							<i class="fas fa-check"></i>
						</div>
					</div>
					<br>
					<div class="accounts-progress">
						<p>Accounts progress: {{ progressBar.accountsReady }} of {{progressBar.accountsTotal}} finished</p>
						<mat-progress-bar mode="determinate" [value]="progressBar.value"></mat-progress-bar>
						<br>
					</div>
				</div>

				<!-- Onboarding complete section-->
				<div class="zesty-table__content" [hidden]="onboardingInProgress">
					<ngx-datatable
						#onboardedAccTable
						class="zesty__table"
						[rows]="onboardedAccounts"
						[columnMode]="'force'"
						[headerHeight]="50"
						[footerHeight]="50"
						[rowHeight]="55"
						[scrollbarH]="true"
						[reorderable]="false"
						[limit]="50"
						[sorts]="[{prop: 'alias', dir: 'desc'}]"
					>
						<!-- Column Templates -->
						<ngx-datatable-column name="Account Name" prop="account_alias"></ngx-datatable-column>
						<ngx-datatable-column name="Account UUID" prop="account_uuid"></ngx-datatable-column>
						<ngx-datatable-column name="Company Name" prop="company_name" headerClass="row-center" cellClass="row-center"></ngx-datatable-column>
						<ngx-datatable-column name="Onboarded" prop="isOnboarded"
																	[width]="100"
																	[resizeable]="false"
																	[sortable]="false"
																	cellClass="row-right overflow-auto"
																	headerClass="row-right"
																	[draggable]="false"
																	[canAutoResize]="false">
							<ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
								<div class="zesty-status">
									<span *ngIf="row.isOnboarded"
												tooltip="Success"
												placement="center"
												class="zesty-status__success"></span>
									<span  *ngIf="!row.isOnboarded"
												 tooltip="Failed"
												 placement="center"
												 class="zesty-status__failure"></span>
								</div>
							</ng-template>
						</ngx-datatable-column>
					</ngx-datatable>
				</div>

			</div>
			<div class="zesty-modal__actions">
				<button *ngIf="!onboardingInProgress" class="zesty-modal__close" (click)="closeEvent()">Close</button>
				<button *ngIf="onboardingInProgress" class="zesty-modal__close" (click)="minifyModal()">Hide</button>
			</div>
		</div>
	</div>
</div>
